import React, { useState, useCallback } from 'react';
import { Tabs, Badge } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { replace as _replace } from 'lodash';
import StorageTab from './components/storageTab';
import MovesGrid from './components/movesGrid';
import InvoicesJournal from './components/invoicesJournal';
import MyMaterials from './components/myMaterials';
import MonthlyReportTab from './components/monthlyReportTab';
import ReferenceTab from './components/referenceTab';

const Materials = () => {
  const [dataVersion, setDataVersion] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [activeTabKey, setActiveTabKey] = useState('storage');

  const refreshData = useCallback(() => {
    setDataVersion((v) => v + 1);
  }, []);

  const items = [
    {
      key: 'storage',
      label: 'Хранение',
      children: <StorageTab dataVersion={dataVersion} onDataChange={refreshData} />,
    },
    {
      key: 'reference',
      label: 'Справочники',
      children: <ReferenceTab dataVersion={dataVersion} onDataChange={refreshData} />,
    },
    {
      key: 'journal',
      label: 'Журнал',
      children: (
        <MovesGrid dataVersion={dataVersion} onDataChange={refreshData} />
      ),
    },
    {
      key: 'invoices',
      label: 'Накладные',
      children: <InvoicesJournal dataVersion={dataVersion} />,
    },
    {
      key: 'my',
      label: (
        <span>
          Мои материалы
          {pendingCount > 0 && (
            <Badge count={pendingCount} offset={[8, -2]} size="small" />
          )}
        </span>
      ),
      children: (
        <MyMaterials
          dataVersion={dataVersion}
          onDataChange={refreshData}
          onPendingCountChange={setPendingCount}
        />
      ),
    },
    {
      key: 'monthly_report',
      label: 'Отчёт за месяц',
      children: (
        <MonthlyReportTab dataVersion={dataVersion} activeTabKey={activeTabKey} />
      ),
    },
  ];

  return (
    <React.Fragment>
      <PageHeader
        title="Материалы"
        style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}
      />
      <Tabs
        activeKey={activeTabKey}
        onChange={setActiveTabKey}
        items={items}
      />
    </React.Fragment>
  );
};

export default Materials;
